export enum OrgAssetTypeEnum {
  Undefined = 0,
  ImageDocumentLibrary = 1,
  OfficeTemplateLibrary = 2
}
